export default "__VITE_ASSET__CpRtY697__"